export default __webpack_public_path__ + "static/media/illi10.1edf2d8f.png";